import React from 'react';
import CurrencyInput from 'react-currency-input-field';
import { Input } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';

const InputCurrency = ({
  onChange,
  brColor,
  value,
  name,
  ...props
}: {
  isDisabled?: boolean;
  brColor?: string;
  value: string | number;
  name: string;
  onChange: (value: string | number) => void;
  [key: string]: any;
}): JSX.Element => {
  const [inputValue, setInputValue] = React.useState(value);
  const { watch } = useFormContext();
  const fieldValue = watch(name);

  const handleChange = (value?: string, name?: string, values?: any) => {
    if (!value) {
      setInputValue('0,00');
      onChange(0.0);
      return;
    }
    setInputValue(value);
    onChange(values.float);
  };

  React.useEffect(() => {
    setInputValue(fieldValue);
  }, [fieldValue]);

  return (
    <Input
      as={CurrencyInput}
      decimalScale={2}
      allowNegativeValue={false}
      allowDecimals={true}
      groupSeparator=' '
      decimalSeparator=','
      onValueChange={handleChange}
      value={inputValue}
      borderColor={brColor}
      {...props}
    />
  );
};

export { InputCurrency };
